import React from 'react';

// Tab order follows the Figma nav bar (787:14697). Profile now lives in the header (#49).
export const NAV_TABS = [
  { id: 'play', label: 'Play', icon: 'padel' },
  { id: 'stats', label: 'Stats', icon: 'bar_chart' },
  { id: 'events', label: 'Events', icon: 'trophy' },
  { id: 'insights', label: 'Insights', icon: 'star' },
];

export default function BottomNavBar({ activeTab, onTabChange }) {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 w-full z-50 border-t border-slate-800/80 shadow-[0_-4px_25px_rgba(0,0,0,0.5)] pt-1.5 bottom-nav-bar select-none"
      style={{ backgroundColor: 'var(--surface-container)' }}
      aria-label="Main navigation"
    >
      <div className="w-full max-w-[680px] mx-auto flex items-center justify-center">
        {NAV_TABS.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              aria-current={isActive ? 'page' : undefined}
              className="flex-1 min-w-0 flex flex-col items-center gap-1 group cursor-pointer border-none bg-transparent outline-none focus:outline-none"
            >
              {/* Material 3 active indicator (56 x 32 pill) */}
              <div
                className="w-14 h-8 rounded-2xl flex items-center justify-center transition-colors duration-200"
                style={
                  isActive
                    ? { backgroundColor: 'var(--primary)', color: 'var(--on-primary)' }
                    : { color: 'var(--on-surface)' }
                }
              >
                <span className="material-symbols-outlined text-[24px] leading-none">
                  {tab.icon}
                </span>
              </div>

              {/* Label */}
              <span
                className="text-xs font-medium leading-4 tracking-[0.5px] transition-colors"
                style={{ color: isActive ? 'var(--primary)' : 'var(--on-surface)' }}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
